/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsBalancesRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsBalancesResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsBalances = (request: GetSavingsBalancesRequest, options?: CashRequestOptions) => post<GetSavingsBalancesRequest, GetSavingsBalancesResponse>("/2.0/cash/get-savings-balances", request, {...options, rejectOnError: true })